import styled from "@emotion/styled";
import { PageHeader } from "components/Common/Page";

export const TrucksHeaderContainer = styled(PageHeader)(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: 20,
	display: "flex",
	flexDirection: "column",
	boxSizing: "border-box",
	gap: 16,
	position: "sticky",
	top: 0,
	zIndex: 998,
	"> span": {
		height: 24
	},
	"> button": {
		width: 115
	},
	[theme.breakpoints.down("lg")]: {
		top: 56
	}
}));

export const TrucksHeaderTopRow = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	gap: 8,
	flexWrap: "wrap"
}));

export const TrucksHeaderHeadContainer = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	h4: {
		margin: 0
	},
	"> span": {
		height: 42,
		width: "50%"
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		alignItems: "flex-start",
		gap: 24,
		"> span": {
			width: "100%"
		}
	}
}));
